var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, IsArray, IsUUID } from 'class-validator';
/**
 * Adopt an existing standalone appointment into a treatment plan (TM-9168
 * slice 2). Link-only: the appointment keeps its scheduling, gains a plan
 * link, and consumes the listed plan units.
 */
export class AssociateAppointmentWithPlanDto {
    treatmentPlanId;
    billableServiceItemIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], AssociateAppointmentWithPlanDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    ArrayMinSize(1),
    __metadata("design:type", Array)
], AssociateAppointmentWithPlanDto.prototype, "billableServiceItemIds", void 0);
//# sourceMappingURL=associate-appointment-with-plan.dto.js.map